import withNavigate from "../../../routes/withNavigate.jsx";
import AlertsContainer from "./AlertsContainer.jsx";
import AlertsStore from "./AlertsStore.js";

export default AlertsStore(withNavigate(AlertsContainer));
